import $ from 'jquery'
import axios from 'axios'
import { formatMoney } from './helpers'

const ajaxCart = $('.ajax-cart')
const ajaxCartBox = $('.ajax-cart-box')

if (ajaxCartBox.length) {
  const cartUrl = ajaxCartBox.attr('data-cart-url')
  const cartChangeUrl = ajaxCartBox.attr('data-cart-change-url')
  const cartAddUrl = ajaxCartBox.attr('data-cart-add-url')
  const cartUpdateUrl = ajaxCartBox.attr('data-cart-update-url')

  /*
    Ajax add to cart
  */

  $('[action*="/cart/add"]').on('submit', function (e) {
    e.preventDefault()

    const form = $(this)
    const url = form.attr('action') + '.js'
    const method = form.attr('method')
    const data = form.serialize()

    console.log(url)

    $.ajax({
      type: 'POST',
      url,
      method,
      data,
      dataType: 'html',
      success: function (data) {
        updateCart()
      },
      error: function (err) {
        if (err.status === 422) {
          $('.product-form-error').show()
        } else {
          console.error('Error status:', err.status)
          console.error('Error response text:', err.message)
          console.error('Error details:', err)
        }
      },
    })
  })

  $('.quick-add-button').on('click', function (e) {
    e.preventDefault()

    const id = Number($(this).attr('href').split('/').at(-1))

    $.ajax(cartAddUrl + '.js', {
      data: JSON.stringify({ id, quantity: 1 }),
      contentType: 'application/json',
      type: 'POST',
      dataType: 'html',
      success: function () {
        updateCart()
      },
    })
  })

  $(document).on(
    'mouseup',
    '.bndlr-add-to-cart, .bndlr-add-bundle-to-cart, .bndlr-add-sectioned-bundle-to-cart',
    function () {
      setTimeout(function () {
        updateCart()
        openCart()
      }, 1200)

      setTimeout(function () {
        updateCart()
      }, 2000)
    }
  )

  /*
    Bundle add to cart
  */

  /*
  Cart links
*/

  $(`[href="${cartUrl}"]`).on('click', function (e) {
    e.preventDefault()
    openCart()
  })

  /*
  Open / Close
*/

  function closeCart() {
    ajaxCart.removeClass('ajax-cart--active')
    unlockScroll()
  }

  /* 
  Ajax cart listeners
*/

  $(document).on('click', '.ajax-cart, .ajax-cart-header-close', function (e) {
    closeCart()
  })

  $(document).on('click', '.ajax-cart-box', function (e) {
    e.stopPropagation()
  })

  $(document).on('click', '.ajax-cart .quantity-selector button, .ajax-cart-item-remove', function (e) {
    e.preventDefault()
    const item = $(this).parents('.ajax-cart-item')
    const id = item.attr('data-line-item-key')
    const isDown = $(this).hasClass('quantity-selector-down')
    const isRemove = $(this).hasClass('ajax-cart-item-remove')
    const currentQuantity = Number(item.find('.quantity-selector input').val())

    $('body').attr('cart-scroll-y', $('.ajax-cart-form-flex').scrollTop())

    // Stop if cant go any lower
    if (isDown && currentQuantity === 0) return

    const quantity = (function () {
      if (isRemove) {
        return 0
      } else if (isDown) {
        return currentQuantity - 1
      } else {
        return currentQuantity + 1
      }
    })()

    $.ajax(cartChangeUrl + '.js', {
      data: JSON.stringify({ id, quantity }),
      contentType: 'application/json',
      type: 'POST',
      dataType: 'html',
      success: function () {
        updateCart()
      },
    })
  })

  /*
    Recommended products
  */

  $(document).on('click', '.ajax-cart-rec .ajax-cart-rec-item-add', function (e) {
    e.preventDefault()

    const root = $(this).parents('.ajax-cart-rec-item')
    const id = Number(root.find('[name="id"]').val())

    axios.post('/cart/add.js', { id }).then(() => {
      updateCart()
    })
  })

  $(document).on('change', '.ajax-cart-rec select', function (e) {
    const root = $(this).parents('.ajax-cart-rec-item')
    const productJsonRaw = root.attr('data-product')

    const productJson = JSON.parse(productJsonRaw)
    const variantId = Number($(this).val())
    const selectedVariant = productJson.variants.find((v) => v.id === variantId)
    const price = formatMoney(selectedVariant.price).replace('.00', '')

    root.find('img').attr('src', selectedVariant.featured_image.src)
    root.find('.ajax-cart-rec-item-price').html(price)
  })

  /*
  Giftwrap
*/

  $(document).on('click', '.ajax-cart-giftwrap-header', function (e) {
    $(this).next().slideToggle()
    $(this).parent().toggleClass('ajax-cart-giftwrap--active')
  })

  $(document).on('click', '.ajax-cart-giftwrap .quantity-selector button', function () {
    const up = $(this).hasClass('quantity-selector-up')
    const input = $(this).parent().find('input')
    const current = Number(input.val())

    if (up) {
      input.val(current + 1)
    } else if (current > 1) {
      input.val(current - 1)
    }
  })

  $(document).on('click', '.ajax-cart-giftwrap-product-right button', function (e) {
    const root = $(this).parents('.ajax-cart-giftwrap')
    const id = root.attr('data-id')
    const quantity = Number(root.find('.quantity-selector input').val())

    $.ajax(cartAddUrl + '.js', {
      data: JSON.stringify({ id, quantity }),
      contentType: 'application/json',
      type: 'POST',
      dataType: 'html',
      success: function () {
        updateCart()
      },
    })
  })

  /*
  Gift note
*/

  $(document).on('click', '.ajax-cart-note-header', function (e) {
    $(this).next().slideToggle()
    $(this).parent().toggleClass('ajax-cart-note--active')
  })

  $(document).on('keyup', '.ajax-cart-note-note', function () {
    $.ajax(cartUpdateUrl + '.js', {
      data: JSON.stringify({ note: $(this).val() }),
      contentType: 'application/json',
      type: 'POST',
      dataType: 'html',
    })
  })
}

/*
  Update cart
*/

export function lockScroll() {
  const position = window.scrollY
  $('body').attr('data-position', position)
  $('body').addClass('lock-scroll')
  $('body').css('top', `-${position}px`)
}

export function unlockScroll() {
  const position = Number($('body').attr('data-position'))
  $('body').removeClass('lock-scroll')
  $('body').css('top', ``)
  $('body').removeAttr('data-position')
  window.scrollTo(0, position)
}

export function updateCart() {
  if (ajaxCartBox.length) {
    // Fetch new section
    $.get('/?section_id=ajax-cart', async function (data) {
      // Current cart
      const ajaxCart = $('.ajax-cart')

      // Parse html
      const parsedHTML = $.parseHTML(data)
      const newAjaxCart = $(parsedHTML)

      // Find needed data
      const itemCount = newAjaxCart.find('.ajax-cart-box').attr('data-item-count')
      const newBox = newAjaxCart.find('.ajax-cart-box')

      // Use it
      $('#header-cart-count').text(itemCount)
      ajaxCart.html(newBox)

      // Make sure to keep scroll
      const scrollPos = Number($('body').attr('cart-scroll-y'))
      ajaxCart.find('.ajax-cart-form-flex').scrollTop(scrollPos)
      $('body').removeAttr('cart-scroll-y')

      // Sync embroidery
      try {
        // Get cart ajax
        const res = await axios.get('/cart.json')

        // Count embroideries
        let total = 0
        let embroideryTotal = 0

        res.data.items.forEach((item) => {
          if (item.properties && item.properties['Embroidery text']) {
            total += item.quantity
          } else if (item.id === 40890756530242) {
            embroideryTotal += item.quantity
          }
        })

        // Update embroidery if some
        if (total !== embroideryTotal) {
          await axios.post('/cart/update.js', {
            updates: {
              40890756530242: total,
            },
          })
        }
      } catch (err) {
        console.log(err)
      }

      // Open the cart
      setTimeout(function () {
        openCart()

        try {
          bndlr.updateCartDiscounts()
        } catch (err) {
          console.log(err)
        }
      }, 10)
    })
  }
}

export function openCart() {
  if (ajaxCartBox.length) {
    ajaxCart.addClass('ajax-cart--active')
    lockScroll()
  }
}
